import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card, Button, Container } from 'react-bootstrap';
import { FaCalendarAlt, FaClock, FaLaptop, FaUser } from 'react-icons/fa';
import './ConfirmationFinal.css'; // 
import { useLanguage } from '../i18n/LanguageContext';

function ConfirmationFinal() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  const appointmentData = location.state?.appointmentData;
  const billingInfo = location.state?.billingInfo;
  const bookingSummary = location.state?.bookingSummary;

  if (!appointmentData) {
    return (
      <Container className="py-5 text-center">
        <h4>{`❌ ${t('booking.noAppointmentData')}`}</h4>
        <Button variant="secondary" onClick={() => navigate('/')}>
          {t('booking.returnHome')}
        </Button>
      </Container>
    );
  }

  const { start_time, end_time, mode } = appointmentData;

  const locale = language === 'en' ? 'en-CA' : 'fr-CA';
  const formattedDate = new Date(start_time).toLocaleDateString(locale);
  const formattedStart = new Date(start_time).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  const formattedEnd = new Date(end_time).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });

  const isGuest = !location.state?.user_id; // simplification : pourrait être affiné avec AuthContext

  return (
    <Container className="py-5 d-flex justify-content-center">
      <Card className="confirmation-card shadow-lg p-4" style={{ maxWidth: '600px', width: '100%' }}>
        <Card.Body className="text-center">
          <h2 className="mb-4 text-success">✅ {t('booking.appointmentConfirmed')}</h2>
          <p className="mb-4">{t('booking.thanksPayment')}</p>

          <div className="text-start mb-4" style={{ fontSize: '16px' }}>
            <p><FaCalendarAlt className="me-2" /><strong>{t('booking.appointmentDate')} :</strong> {formattedDate}</p>
            <p><FaClock className="me-2" /><strong>{t('booking.appointmentTime')} :</strong> {formattedStart} - {formattedEnd}</p>
            <p><FaLaptop className="me-2" /><strong>{t('booking.mode')} :</strong> {mode === 'in_person' ? t('booking.inPerson') : t('booking.virtual')}</p>
            {bookingSummary && (
              <>
                <hr />
                <p><strong>{t('booking.professional')} :</strong> {bookingSummary.providerName}</p>
                <p><strong>{t('booking.service')} :</strong> {bookingSummary.serviceType}</p>
                <p><strong>{t('booking.amountToPay')} :</strong> {bookingSummary.formattedTotal}</p>
              </>
            )}
            {billingInfo && (
              <>
                <hr />
                <p><FaUser className="me-2" /><strong>{t('booking.lastName')} :</strong> {billingInfo.name}</p>
                <p><strong>{t('booking.email')} :</strong> {billingInfo.email}</p>
                <p><strong>{t('booking.phone')} :</strong> {billingInfo.phone}</p>
                <p><strong>{t('booking.address')} :</strong> {billingInfo.address}</p>
              </>
            )}
          </div>

          <Button
            variant="primary"
            onClick={() =>
              navigate(isGuest ? '/' : '/patient/rendez-vous')
            }
          >
            {isGuest ? t('booking.returnHome') : t('booking.viewAppointments')}
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ConfirmationFinal;
